import React from "react";
import styles from "../course/course-update/course-update.module.css";
import Button from "../button";
import { arrowDownBlack, locationIcon } from "../../images";
import TechCourseBanner from "./tech-course-banner";

const hardcodedCohorts = {
  "US & Canada": [
    {
      id: 1,
      location: "US & Canada",
      timezone: "EST",
      startDate: "2025-06-01",
      endDate: "2025-06-14",
      sessionList: [
        { day: "Tuesdays - Project Session", from: "7PM " },
      ],
      ctaLabel: "Join Now",
      subtext: "Limited capacity"
    }
  ],
  "Europe - Africa": [
    {
      id: 2,
      location: "Europe - Africa",
      timezone: "GMT +1",
      startDate: "2025-07-01",
      endDate: "2025-07-14",
      sessionList: [
        { day: "Tuesdays - Project Session", from: "7PM" }
      ],
      ctaLabel: "Join Now",
      subtext: "Limited capacity"
    }
  ]
};

const hardcodedRegions = ["US & Canada", "Europe - Africa"];

const TechCourseUpdate = ({ setIsEnrolOpen, scrollToPayments, selectedRegion, onRegionChange }) => {
  const [open, setOpen] = React.useState(false);  
  const [showCourseBanner, setShowCourseBanner] = React.useState(true);
  const cohortsForSelectedRegion = hardcodedCohorts[selectedRegion] || [];
  // Hardcoded data for the course banner
  const courseBanner = {
    discount: "25",
    title: "New Project Starts in",
    btnLabel: "Get the Deal",
    message: "Note: Immediate team onboarding on payment",
    type: "Link",
    code: "EARLYBIRD30",
    btnUrl: "#payments",
    expandedOnMobile: true
  };
   return (
    <section className={styles["section_no_background"]}>     

      <div className={styles["body_section_no_background"]}>
        <section>
          <div className={styles["sss_title"]}>Upcoming Program Dates</div>
     <div className="w-full mb-6">
        {showCourseBanner && (          <TechCourseBanner
            discount={courseBanner.discount}
            title={courseBanner.title}
            btnLabel={courseBanner.btnLabel}
            message={courseBanner.message}
            scrollToPayments={scrollToPayments}
            setShowBanner={setShowCourseBanner}
            expandedOnMobile={courseBanner.expandedOnMobile}
          />
        )}
      </div>
          {/* Region Selection */}
          <div className={styles["region_select_section"]}>
            {hardcodedRegions.map((regionName) => (
              <span
                key={regionName}
                className={regionName === selectedRegion ? styles["selected_region"] : null}
                onClick={() => onRegionChange(regionName)}
              >
                {regionName}
              </span>
            ))}
          </div>
          {/* Region Selection Dropdown for smaller screens */}
          <div className={styles["select_cont"]}>
            <div className={styles["select_dropdown"]}>
              <div className={styles["select"]} onClick={() => setOpen(!open)}>
                <img src={locationIcon} alt="location-icon" loading="lazy" />
                <span>{selectedRegion || "Select Region"}</span>
                <img className={styles["arrow"]} src={arrowDownBlack} alt="arrow black" loading="lazy" />
              </div>
              {open && (
                <div className={styles["select_options"]}>
                  {hardcodedRegions.map((regionName) => (
                    <div
                      key={regionName}
                      className={`${styles["dropdown"]} ${regionName === selectedRegion ? styles["selected"] : ""}`}
                      onClick={() => {
                        onRegionChange(regionName);
                        setOpen(false);
                      }}
                    >
                      {regionName}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          {/* Program Dates */}
          <div className={styles["program_dates"]}>
            {cohortsForSelectedRegion.length > 0 ? (
              cohortsForSelectedRegion.map((cohort) => (
                <div className={styles["program_date_point"]} key={cohort.id}>
                  <div className={styles["program_info_block"]}>
                    <div className={styles["program_info_items"]}>
                      <div className="font-normal text-xs leading-5 text-[#333333] flex">
                      New client project every week
                      </div>
                      <div className={styles["program_info_period"]}>
                      Join a team today
                      </div>
                    </div>
                    {cohort.sessionList &&
                      cohort.sessionList.map((session, id) => (
                        <div className={styles["program_info_items"]} key={id}>
                          <div className={styles["program_info_title"]}>{session.day}s</div>
                          <div className={styles["program_info_sessions"]}>
                            {`${session.from}  ${cohort.timezone}`}
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className={styles["program_button_block"]}>
                    <Button
                      variant="secondary"
                      className={styles["program_btn"]}
                      onClick={() => scrollToPayments(cohort.id)}
                    >
                      {cohort.ctaLabel}
                    </Button>
                    {cohort.subtext ? <div className="font-normal justify-center text-[12px] leading-[20px] text-[#333333]">{cohort.subtext}</div> : null}
                  </div>
                </div>
              ))
            ) : (
              <div className={styles["title"]}>No Courses Available in this Region right now.</div>
            )}
          </div>
        </section>
      </div>
    </section>
  );
};

export default TechCourseUpdate;
